import { render, staticRenderFns } from "./participation.vue?vue&type=template&id=1883b8df&scoped=true"
import script from "./participation.vue?vue&type=script&lang=js"
export * from "./participation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1883b8df",
  null
  
)

export default component.exports